import axios from "axios";
const { API_BACKEND_HOST } = process.env;
const responseFormat = { error: "", data: null };

export const create = async (payload) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const { data } = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Modality`,
      payload
    );

    return data;
  } catch (e) {
    return { error: true, message: e || 'error' }
  }
}

export const update = async (id, payload) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const { data } = await axios.patch(
      `${API_BACKEND_HOST}${languageId}/v1/Modality/${id}`,
      payload
    );

    return data;
  } catch (e) {
    return { error: true, message: e || 'error' }
  }
}
